import { useContext } from 'react';
import { DialogContext } from './contexts';

export default function useDialog() {
  const { dialog } = useContext(DialogContext);
  return dialog;
}
